import * as React from 'react';
import { PrintingLinearProgress } from '../styled';
import { LinearProgressProps } from '@kis-technologies/kis-ui';

/**
 * Linear Progress that animates to display progress
 */

export const LinearProgress = (props: LinearProgressProps) => {
  return <PrintingLinearProgress {...props} />;
};
